import { defineMessages } from 'react-intl';

export default defineMessages({
    indicateAgreement: {
        id: 'ml.tcpaConsent.common.Please indicate your agreement',
        defaultMessage: 'Please indicate your agreement'
    },
    phoneAgreementDesc: {
        id: 'ml.tcpaConsent.common.phoneAgreementDescription',
        defaultMessage: 'We sometimes reach out to consumers by call and/or text to provide helpful information about our products or services. Do you agree that marketing calls and/or texts can be made to the phone number(s) provided on behalf of Farmers®, Foremost®, Bristol West®, Farmers Life® and 21st Century® insurance entities or their representatives using an automated telephone dialing system and/or an artificial or pre-recorded voice?  Your consent is not a condition of purchase.'
    },
    tcpaPhoneCall: {
        id: 'ml.tcpaConsent.common.Phone call',
        defaultMessage: 'Phone call'
    },
    tcpaText: {
        id: 'ml.tcpaConsent.common.Text',
        defaultMessage: 'Text'
    }
});
